import * as Components from "./components";
import * as Assets from "./assets";
import "./index.css";

const VCL = {
  Components,
  Assets,
};
export default VCL;
